import { mdiCheckboxBlankCircleOutline } from '@mdi/js'

const themeConfig = {
  app: {
    name: 'Piiri',
    logo: require('/public/images/piiri_p_2025.png'),
    isDark: false,
    isRtl: false,
    contentLayoutNav: 'vertical', // vertical, horizontal
    routeTransition: 'scroll-x-transition', // https://vuetifyjs.com/en/styles/transitions/#api
    // ! `semi-dark` isn't available for horizontal nav menu
    skinVariant: 'default', // default, bordered, semi-dark
    contentWidth: 'boxed',
  },
  menu: {
    isMenuHidden: false,
    isVerticalNavMini: false,
    verticalMenuAccordion: true,
    groupChildIcon: mdiCheckboxBlankCircleOutline,
    horizontalNavMenuGroupOpenOnHover: true,
  },
  appBar: {
    /*
    ! In Content Layout Horizontal Nav type `hidden` value won't work
    ! In Content Layout Horizontal Nav type value of `type` will affect both Appbar and Horizontal Navigation Menu
    */
    type: 'fixed', // fixed, static, hidden
    isBlurred: true,
  },
  footer: {
    type: 'static', // fixed, static, hidden
  },
  themes: {
    light: {
      primary: '#333333',
      accent: '#333333',
      secondary: '#8A8D93',
      success: '#53a615',
      info: '#3c86c8',
      warning: '#FFA300',
      error: '#DD4449',
      gradient: '#c48eff'
    },
    dark: {
      primary: '#333333',
      accent: '#333333',
      secondary: '#8A8D93',
      success: '#53a615',
      info: '#3c86c8',
      warning: '#FFA300',
      error: '#DD4449',
      gradient: '#c48eff'
    },
  },
}

export default themeConfig
